import usePosOrderCurrentAction from "@/shared/atoms/usePosOrderCurrentAction";
import { DeliveryMethods } from "@/shared/utils/enum";
import { useSetModal } from "@/shared/atoms/useModal";
import usePosOrderUser from "@/shared/atoms/usePosOrderUser";
import usePosOrderDeliveryMethod from "@/shared/atoms/usePosOrderDeliveryMethodAtom";
import useActionClick from "./useActionClick";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useTranslation } from "react-i18next";
import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";

const useCustomerOrderHistoryAction = (): PosMenuAction => {
  const { t } = useTranslation();
  const [deliveryMethod] = usePosOrderDeliveryMethod();
  const [orderUser] = usePosOrderUser();
  const setModal = useSetModal();

  return {
    name: "customerOrderHistoryModal" as CurrentActionTypes,
    label: t("posOrders.orderHistory"),
    set: () =>
      setModal("customerOrderHistory", {
        userId: orderUser?.item_id,
      }),
    instantSet: true,
    filtered: false,
    disabled:
      deliveryMethod === DeliveryMethods.DINE_IN ||
      Boolean(orderUser?.item_id) === false,
    iconVariant:"clipboardcheck",
  };
};

const CustomerOrderHistoryAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = useCustomerOrderHistoryAction();
  const handleClick = useActionClick(action);

  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default CustomerOrderHistoryAction;
